<template>
    <base-form
        ref="form"
        v-model="form"
        :api="api"
        :mapper="mapper"
        :entity-id="entityId"
        :title="title"
        :disabled="disabled"
        disable-delete-button
    >
        <form-panel>
            <form-two-col-row>
                <template #col1>
                    <text-input
                        v-model="form.spreadMax"
                        v-validate.immediate="
                            'required|integer|min_value:0|max_value:240'
                        "
                        type="number"
                        name="spreadMax"
                        label="settings.eod_spread_max"
                        :error-messages="errors.collect('spreadMax')"
                        :data-vv-as="$t('settings.eod_spread_max')"
                    ></text-input>
                </template>
                <template #col2>
                    <text-input
                        v-model="form.lateAcceptMinPrep"
                        v-validate.immediate="
                            'required|integer|min_value:0|max_value:60'
                        "
                        type="number"
                        name="lateAcceptMinPrep"
                        label="settings.eod_late_accept_min_prep"
                        :error-messages="errors.collect('lateAcceptMinPrep')"
                        :data-vv-as="$t('settings.eod_late_accept_min_prep')"
                    ></text-input>
                </template>
            </form-two-col-row>
            <form-two-col-row>
                <template #col1>
                    <text-input
                        v-model="form.preorderPickupGap"
                        v-validate.immediate="
                            'required|integer|min_value:0|max_value:120'
                        "
                        type="number"
                        name="preorderPickupGap"
                        label="settings.eod_preorder_pickup_gap"
                        :error-messages="errors.collect('preorderPickupGap')"
                        :data-vv-as="$t('settings.eod_preorder_pickup_gap')"
                    ></text-input>
                </template>
            </form-two-col-row>
            <eod-spread-tiers v-model="form.tiers"></eod-spread-tiers>
        </form-panel>
    </base-form>
</template>

<script>
import RestApiType from '@/api/RestApiType'
import MapperType from '@/services/mapper/MapperType'
import FormBaseMixin from '@/components/mixins/FormBase'
import FormPanel from '@/components/form/FormPanel.vue'
import FormTwoColRow from '@/components/form/FormTwoColRow.vue'
import TextInput from '@/components/form/Inputs/TextInput.vue'
import EodSpreadTiers from './EodSpreadTiers.vue'

export default {
    components: {
        FormPanel,
        FormTwoColRow,
        TextInput,
        EodSpreadTiers,
    },
    mixins: [FormBaseMixin],
    data: () => ({
        api: RestApiType.EOD_SPREAD_SETTINGS,
        mapper: MapperType.EOD_SPREAD_SETTING_FORM,
        form: {
            spreadMax: null,
            lateAcceptMinPrep: null,
            preorderPickupGap: null,
            tiers: [],
        },
    }),
    computed: {
        title() {
            return this.$t('settings.eod_spread_page_title')
        },
    },
}
</script>
